import { IconButton, useMediaQuery, useTheme } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'

import { lang } from '../../../../localization'
import useStyles from './styles/index.styles'

type Props = {
  images: string[]
  isCover: boolean
}

export const Gallery = ({ images, isCover }: Props) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const [openGallary, setOpenGallary] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const [currentIndex, setCurrentIndex] = useState(0) // for preview carousel

  if (!images || images.length === 0) {
    return null
  }

  const slides = images.map((src) => ({ src }))

  const renderPreview = () => {
    if (isSmall) {
      return (
        <div
          className={classes.image}
          onClick={() => {
            setActiveIndex(0)
            setOpenGallary(true)
          }}>
          <img src={images[0]} alt="preview" className={classes.smallScreen} />
        </div>
      )
    }

    if (images.length === 1 || isCover) {
      return (
        <div
          className={classes.image}
          onClick={() => {
            setActiveIndex(0)
            setOpenGallary(true)
          }}>
          <img
            src={images[0]}
            alt="preview"
            className={[classes.cover, !isCover && classes.cover1].join(' ')}
          />
        </div>
      )
    }

    if (images.length === 2 || images.length === 3) {
      return (
        <div className={classes.previewRow}>
          {images.slice(0, images.length).map((img, idx) => (
            <div
              key={idx}
              className={classes.image}
              onClick={() => {
                setActiveIndex(idx)
                setOpenGallary(true)
              }}>
              <img
                src={img}
                alt={`preview-${idx}`}
                className={[
                  classes.cover,
                  images.length === 2 && classes.cover2,
                  images.length === 3 && classes.cover3
                ].join(' ')}
              />
            </div>
          ))}
        </div>
      )
    }

    // More than 3 → show 3 with carousel arrows
    const visibleImages = images.slice(currentIndex, currentIndex + 3)

    return (
      <div className={classes.previewCarousel}>
        {/* Left arrow */}
        {currentIndex > 0 && (
          <IconButton
            className={classes.arrowLeft}
            onClick={() => setCurrentIndex((prev) => prev - 1)}>
            <ArrowBackIosIcon
              style={{
                transform: lang === 'fa' ? 'rotate(180deg)' : 'none'
              }}
            />
          </IconButton>
        )}

        <div className={[classes.previewRow, classes.previewRowPlus].join(' ')}>
          {visibleImages.map((img, idx) => {
            const realIndex = currentIndex + idx
            return (
              <div
                key={realIndex}
                className={[classes.image, classes.imagePlus].join(' ')}
                onClick={() => {
                  setActiveIndex(realIndex)
                  setOpenGallary(true)
                }}>
                <img
                  src={img}
                  alt={`preview-${realIndex}`}
                  className={classes.cover}
                />
              </div>
            )
          })}
        </div>

        {/* Right arrow */}
        {currentIndex + 3 < images.length && (
          <IconButton
            className={classes.arrowRight}
            onClick={() => setCurrentIndex((prev) => prev + 1)}>
            <ArrowForwardIosIcon
              style={{
                transform: lang === 'fa' ? 'rotate(180deg)' : 'none'
              }}
            />
          </IconButton>
        )}
      </div>
    )
  }

  return (
    <>
      <div className={classes.imageContainer}>{renderPreview()}</div>
      <Lightbox
        open={openGallary}
        close={() => setOpenGallary(false)}
        slides={slides}
        index={activeIndex}
        plugins={[Thumbnails]}
        thumbnails={{
          position: 'bottom',
          width: 100,
          height: 100,
          imageFit: 'cover'
        }}
        carousel={{ finite: true }}
        styles={{
          container: { backgroundColor: 'black' }
        }}
      />
    </>
  )
}
